import { SelectMulti, ISelectMultiOption } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { allDataSources, DataSource, IncludeEmailSource } from 'entities/campaign/rules';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<IncludeEmailSource>;

export const Form: React.FC<FormProps> = props => {
  const allItems: ISelectMultiOption<string>[] = allDataSources.map(source => ({
    value: source,
    label: source,
  }));

  const selected: ISelectMultiOption<string>[] = props.rule.includedSources.map(source => ({
    value: source,
    label: source,
  }));

  const onUpdate = (selectedItems: ISelectMultiOption<string>[] | null) =>
    props.update(props.rulesetId, props.ruleIndex, {
      ...props.rule,
      includedSources: selectedItems?.map(updatedItems => updatedItems.value as DataSource) ?? [],
    });

  return (
    <div data-testid="IncludeEmailSource">
      <SelectMulti
        ariaLabel="Show if email has been scraped from"
        label="Show if email has been scraped from"
        options={allItems}
        value={selected}
        onChange={onUpdate}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
